import { OptimizePlanRequest, OptimizePlanResponse, ProductionPlanService } from "@/api"
import { useTaskWithProgress } from "@/api/hooks/useTaskWithProgress"
import { lastOptimizeMethodAtom } from "@/atoms/optimization";
import ResultWithProgress from "@/components/ResultWithProgress"
import { useQueryClient } from "@tanstack/react-query";
import { useSetAtom } from "jotai";
import { Button } from "primereact/button"
import { useMountEffect } from "primereact/hooks";
import { useState, useEffect } from "react";
import { RadioButton } from 'primereact/radiobutton';


interface OptimizerProps {
  originalResponse: OptimizePlanResponse,
  optimizeRequest: OptimizePlanRequest,
  onBack(): void;
  onProceed(response: OptimizePlanResponse): void;
}

const Optimizer = ({originalResponse,optimizeRequest,onBack,onProceed} : OptimizerProps) => {
  const queryClient = useQueryClient()
  const [optimizeMethod, setOptimizeMethod] = useState<OptimizePlanRequest.optimize>(optimizeRequest.optimize);
  const setLastOptimizeMethod = useSetAtom(lastOptimizeMethodAtom)

  const request = {
    ...optimizeRequest,
    optimize: optimizeMethod,
  }

  const {
    isLoading,
    isFetched,
    progress,
    lastLog,
    logs,
    isError,
    error,
    data,
    refetch
  } = useTaskWithProgress(
    () => ProductionPlanService.optimize(request),
    ['optimizePlan', optimizeMethod],
    {
      cache: false,
      enabled: false,
    }
  )

  useMountEffect(() => {
    if (isFetched) {
      queryClient.clear()
    }
  })


  const handleBack = () => {
    onBack()
  }

  const handleProceed = () => {
    if(isFetched && data) {
      setLastOptimizeMethod(optimizeMethod)
      onProceed(data)
    }
  }

  useEffect(() => {
    if (isFetched && data) {
      console.log("最適化結果", data)
    }
  }, [isFetched, data])

  return (
    <div className="mt-6">
      <div className="mb-4">
        <h3>最適化方法の選択</h3>
        <div className="flex flex-column gap-3 mt-3">
          <div className="flex align-items-center">
            <RadioButton
              inputId="optimize_method_v2"
              name="optimize_method"
              value="optimize_category_with_user_plan"
              onChange={(e) => setOptimizeMethod(e.value)}
              checked={optimizeMethod === "optimize_category_with_user_plan"}
            />
            <label htmlFor="optimize_method_v2" className="ml-2">改善型最適化(V2)</label>
          </div>
          <div className="flex align-items-center">
            <RadioButton
              inputId="optimize_method4"
              name="optimize_method"
              value="optimize"
              onChange={(e) => setOptimizeMethod(e.value)}
              checked={optimizeMethod === "optimize"}
            />
            <label htmlFor="optimize_method4" className="ml-2">通常最適化</label>
          </div>
          <div className="flex align-items-center">
            <RadioButton
              inputId="optimize_method5"
              name="optimize_method"
              value="simulation_only"
              onChange={(e) => setOptimizeMethod(e.value)}
              checked={optimizeMethod === "simulation_only"}
            />
            <label htmlFor="optimize_method5" className="ml-2">シミュレーションのみ（最適化なし）</label>
          </div>
        </div>
      </div>

      <div className="my-4">
        <Button
          label="最適化を実行"
          icon="pi pi-play"
          iconPos="left"
          onClick={() => refetch()}
          disabled={isLoading}
          loading={isLoading}
        />
      </div>

      <ResultWithProgress
        isObserving={isLoading}
        progress={progress}
        lastLog={lastLog}
        logs={logs}
        isError={isError}
        error={error}>
      </ResultWithProgress>
      <div className="flex flex-row justify-content-between mt-6">
        <Button label="戻る" icon="pi pi-arrow-left"
          iconPos="left" size="small" severity='secondary'
          onClick={handleBack} />
        <Button label="次へ" icon="pi pi-arrow-right"
          iconPos="right" severity='success'
          disabled={isLoading || isError || !isFetched || !data}
          onClick={handleProceed} />
      </div>
    </div>
  )
}

export default Optimizer
